/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Chart_MetricInputs */

const en_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart Metric`)
};

const fr_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicateur graphique`)
};

const de_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrammmetrik`)
};

const it_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrica del grafico`)
};

const ru_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метрика диаграммы`)
};

const es_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrica del gráfico`)
};

const zh_cn2_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图表指标`)
};

const ja_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャートメトリック`)
};

const hi_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चार्ट मीट्रिक`)
};

const pt_pt2_usage_chart_metric = /** @type {(inputs: Usage_Chart_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrica do gráfico`)
};

/**
* | output |
* | --- |
* | "Chart Metric" |
*
* @param {Usage_Chart_MetricInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_chart_metric = /** @type {((inputs?: Usage_Chart_MetricInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Chart_MetricInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_chart_metric(inputs)
	if (locale === "de") return de_usage_chart_metric(inputs)
	if (locale === "it") return it_usage_chart_metric(inputs)
	if (locale === "ru") return ru_usage_chart_metric(inputs)
	if (locale === "es") return es_usage_chart_metric(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_chart_metric(inputs)
	if (locale === "ja") return ja_usage_chart_metric(inputs)
	if (locale === "hi") return hi_usage_chart_metric(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_chart_metric(inputs)
	return en_usage_chart_metric(inputs)
});